module.exports = __webpack_public_path__ + "static/img/document.8d265262.svg";